import { JackpotLevel } from "./api";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { Size, LogGroup, CreateElement, Scale } from "./MyHelpers";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope, ScreenProtocol } from "./ScreenProtocol";
import { Settings } from "./Settings";
import { PickBonusMessages } from "./slot/PickBonus/PickMessage";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { ZIndex } from "./ZIndex";

export class JackpotDisplayPlayCityLink extends IJackpotDisplay {
	protected view: HTMLElement = null;
	protected viewSize: Size = null;
	//Creating elements for JP
	//protected jpTitle: HTMLElement = null;
	protected titleImage: HTMLElement = null;
	protected jp4ContainerJackpot: HTMLElement = null;
	protected diamondImage: HTMLElement = null;
	//protected diamondvalue: HTMLElement = null;
	//protected diamondText: HTMLElement = null;
	protected jp3ContainerJackpot: HTMLElement = null;
	protected rubyImage: HTMLElement = null;
	//protected rubyvalue: HTMLElement = null;
	//protected rubyText: HTMLElement = null;
	protected jp2ContainerJackpot: HTMLElement = null;
	protected emeraldImage: HTMLElement = null;
	protected emeraldvalue: HTMLElement = null;
	protected emeraldText: HTMLElement = null;
	protected jp1ContainerJackpot: HTMLElement = null;
	protected saphireImage: HTMLElement = null;
	protected sapphirevalue: HTMLElement = null;


	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	protected diamondStartTimer: IRandomInterval = null;

	// protected rubyAnim: CanvasSprite = null;
	// protected rubyLocation: Point = new Point(365,80);
	protected rubyStartTimer: IRandomInterval = null;

	// protected shappireAnim: CanvasSprite = null;
	// protected shappireLocation: Point = new Point(635,920);
	protected shappireStartTimer: IRandomInterval = null;

	// protected emeraldAnim: CanvasSprite = null;
	// protected emeraldLocation: Point = new Point(617,720);
	protected emeraldStartTimer: IRandomInterval = null;

	//LOAD JACKPOT SPRITE
	protected jp4SpriteJackpot: CanvasSprite;
	protected jp3SpriteJackpot: CanvasSprite;
	protected jp2SpriteJackpot: CanvasSprite;
	protected jp1SpriteJackpot: CanvasSprite;


	protected titleSpriteAnim: CanvasSprite = null;
	protected titleStartTimer: IRandomInterval = null;


	// protected override jp1text: JackpotText = null;
	// protected override jp2text: JackpotText = null;
	// protected override jp3text: JackpotText = null;
	// protected override jp4text: JackpotText = null;

	protected screenProtocol: ScreenProtocol = null;

	protected logGroup: LogGroup;

	protected systemContext: ISystemContext = null;

	protected allJpTimers: IRandomInterval[] = [];

	protected allJpSpriteAnim: CanvasSprite[] = [];

	public constructor(params: JackpotDisplayParams) {
		super(params);

		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayRappidDiamondPot");

		this.resid = params.resid.Add("JackpotDisplayRappidDiamondPot");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayRappidDiamondPot");

		this.screenProtocol = params.screenProtocol;
	
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";

		//this.viewSize = multigameParams.viewSize;
		this.viewSize = params.viewSize;
		this.logGroup = new LogGroup("JackpotDisplayRappidDiamondPot");

		// this would be "view" with jackpot frames
		this.view = CreateElement("div", {
			//classes: [this.resid.ID()],
			style: {
				position: "absolute",
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				zIndex: "" + ZIndex.JackpotDisplay,
			}
		});
		this.view.className = this.resid.ID();




		this.jp4ContainerJackpot = CreateElement("div", {
			//id: "jp4ContainerJackpot",
			classes: [this.resid.ScopedResourceName("jp4ContainerJackpot")],
			parentToAppend: this.view,
			style: {
				position: "absolute",
				left: Scale.Xpx(8),
				top: Scale.Ypx(0),

				// need to get position from image
				width: Scale.Wpx(1906),
				height: Scale.Hpx(450),
				display: "flex",
				alignItems : "center",
				justifyContent : "center",
			}
		});

		this.jp3ContainerJackpot = CreateElement("div", {
			//id: "jp3ContainerJackpot",
			classes: [this.resid.ScopedResourceName("jp3ContainerJackpot")],
			parentToAppend: this.view,
			style: {
				position: "absolute",
				top: Scale.Ypx(405),
				left: Scale.Xpx(317),
				width: Scale.Wpx(1336),
				height: Scale.Hpx(400),
				display: "flex",
				alignItems : "center",
				justifyContent : "center",
			}
		});



		//Emerald Jackpot
		this.jp2ContainerJackpot = CreateElement("div", {
			//id: "jp2ContainerJackpot",
			classes: [this.resid.ScopedResourceName("jp2ContainerJackpot")],
			style:
			{
				position: "absolute",
				bottom: Scale.Ypx(0),
				left: Scale.Xpx(93),
				width: Scale.Wpx(897),
				height: Scale.Hpx(300),
				display : "flex",
				alignItems : "center",
				justifyContent : "center",
			}
		});

		
		this.view.appendChild(this.jp2ContainerJackpot);

		//Shappire Jackpot
		this.jp1ContainerJackpot = document.createElement("div");
		//this.jp1ContainerJackpot.setAttribute("id", "shappireBack");
		this.jp1ContainerJackpot.classList.add(this.resid.ScopedResourceName("jp1ContainerJackpot"));
		this.jp1ContainerJackpot.style.position = "absolute";
		this.jp1ContainerJackpot.style.bottom = Scale.Ypx(0);
		this.jp1ContainerJackpot.style.left = Scale.Xpx(940);
		this.jp1ContainerJackpot.style.width = Scale.Wpx(897);
		this.jp1ContainerJackpot.style.height = Scale.Hpx(300);	
		this.jp1ContainerJackpot.style.display = "flex",
		this.jp1ContainerJackpot.style.alignItems = "center";
		this.jp1ContainerJackpot.style.justifyContent = "center";
		this.view.appendChild(this.jp1ContainerJackpot);





		// recieve message from first screen
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.DiamondAnimation.msgname, (m) => this.DiamondAnimation((<PickBonusMessages.DiamondAnimation>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.JpShowFinish.msgname, (m) => this.JpShowFinish((<PickBonusMessages.JpShowFinish>m)), this.screenProtocolScope);
	}


	protected DiamondAnimation(message: PickBonusMessages.DiamondAnimation) {
		this.allJpTimers.forEach((anim: IRandomInterval) => {
			anim.Stop();
		});

		if (message.hitJp == 1) {
			this.jp1SpriteJackpot.Start(true);
		}

		if (message.hitJp == 2) {
			this.jp2SpriteJackpot.Start(true);
		}

		if (message.hitJp == 3) {
			this.jp3SpriteJackpot.Start(true);
		}

		if (message.hitJp == 4) {
			this.jp4SpriteJackpot.Start(true);
		}
	}

	protected JpShowFinish(message: PickBonusMessages.JpShowFinish) {
		this.allJpSpriteAnim.forEach((anim: CanvasSprite) => {
			if (anim.sprite.Running()) {
				anim.Repeat(false);
				//anim.Start(false);
				// anim.sprite.Stop();
				// anim.sprite.Update();
			}
		});

		this.StartAnimations();
	}

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		resourceManager.Add(new SpriteResource(this.jackpot +"JackpotDisplay"+Settings.JackpotDisplayType + "/Sprites/jp4Frame", this.resid.Add("jp4_sprite"), true, this.logGroup.Add("jp4_sprite"), true));
		resourceManager.Add(new SpriteResource(this.jackpot +"JackpotDisplay"+Settings.JackpotDisplayType + "/Sprites/jp3Frame", this.resid.Add("jp3_sprite"), true, this.logGroup.Add("jp3_sprite"), true));
		resourceManager.Add(new SpriteResource(this.jackpot +"JackpotDisplay"+Settings.JackpotDisplayType + "/Sprites/jp2Frame", this.resid.Add("jp2_sprite"), true, this.logGroup.Add("jp2_sprite"), true));
		resourceManager.Add(new SpriteResource(this.jackpot +"JackpotDisplay"+Settings.JackpotDisplayType + "/Sprites/jp1Frame", this.resid.Add("jp1_sprite"), true, this.logGroup.Add("jp1_sprite"), true));

		//this.TitlePrepare(resourceManager);
		//resourceManager.Add(new FontResource(this.jackpot +"JackpotDisplay"+ Settings.JackpotDisplayType + "/fonts/fontStyle.ttf", this.resid.ScopedResourceName("JackpotFont")));
	}

	public TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		//resourceManager.Add(new SpriteResource(this.jackpot +"JackpotDisplay"+  Settings.JackpotDisplayType + "/Sprites/titleJackpotDisplay", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public TitleLoaded(resourceManager: IReadOnlyResourceManager) {
		// this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.X(1920), Scale.Y(250))});
		// this.titleSpriteAnim.View().style.position = "absolute";
		// this.titleSpriteAnim.View().style.bottom = Scale.Ypx(-120);
		// this.titleSpriteAnim.Scale(1.5);
		// this.view.appendChild(this.titleSpriteAnim.View());
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		//this.TitleLoaded(resourceManager);




		let jackpotjp4TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("jp4text"),
			width: Scale.W(1280),
			height: Scale.H(210),
			color:  "orangered",
			color2: "yellow",
			font: "NotoSansDisplay-Bold",
			defaultValue: 0,
			//stroke : false,
			//bold: false,
			
		}			
		
		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jackpotjp4TextParams );
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(308);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(170); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jp4ContainerJackpot.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());

		//create params 
		let jackpotjp3TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("jp3text"),
			width: Scale.W(1200),
			height: Scale.H(190),
			color:  "orangered",
			color2: "yellow",
			font: "NotoSansDisplay-Bold",
			defaultValue: 0,
			//stroke : false,
			//bold: false,
	
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jackpotjp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(45);//100
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(160);//145
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.jp3ContainerJackpot.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

	
		//create params 
		let jackpotjp2TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("jp2text"),
			width: Scale.W(700),
			height: Scale.H(125),
			color:  "orangered",
			color2: "yellow",
			font: "NotoSansDisplay-Bold",
			defaultValue: 0,
			//stroke : false,
			//bold: false			
		}

		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jackpotjp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(105);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(112);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.jp2ContainerJackpot.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());
		//create params 
		let jackpotjp1TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("jp1text"),
			width: Scale.W(700),
			height: Scale.H(125),
			color:  "orangered",
			color2: "yellow",
			font: "NotoSansDisplay-Bold",
			defaultValue: 0,
			//stroke : false,
			//bold: false			
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jackpotjp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(105);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(112);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		this.jp1ContainerJackpot.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());


		//this.jp4ContainerJackpot.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("diamond_frame")).CssBackground();


		this.jp4SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("jp4_sprite")).sprite, canvasSize: new Size(Scale.X(1900), Scale.Y(450))});
		//this.jp4SpriteJackpot.Start();
		this.jp4ContainerJackpot.appendChild(this.jp4SpriteJackpot.View());


		//this.jp3ContainerJackpot.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("ruby_frame")).CssBackground();
		this.jp3SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("jp3_sprite")).sprite, canvasSize: new Size(Scale.X(1336), Scale.Y(450))});
		//this.jp3SpriteJackpot.Start();
		this.jp3ContainerJackpot.appendChild(this.jp3SpriteJackpot.View());


		//this.jp2ContainerJackpot.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("emerald_frame")).CssBackground();
		this.jp2SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("jp2_sprite")).sprite, canvasSize: new Size(Scale.X(876), Scale.Y(350))});
		//this.jp2SpriteJackpot.Start();
		this.jp2ContainerJackpot.appendChild(this.jp2SpriteJackpot.View());




		this.jp1SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("jp1_sprite")).sprite, canvasSize: new Size(Scale.X(876), Scale.Y(350))});
		//this.jp1SpriteJackpot.Start();
		this.jp1ContainerJackpot.appendChild(this.jp1SpriteJackpot.View());

		this.allJpSpriteAnim.push(this.jp4SpriteJackpot);
		this.allJpSpriteAnim.push(this.jp3SpriteJackpot);
		this.allJpSpriteAnim.push(this.jp2SpriteJackpot);
		this.allJpSpriteAnim.push(this.jp1SpriteJackpot);


		// repeat at random intervals winthin 5 to 10 seconds
		this.diamondStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 10000, 30000, () => this.jp4SpriteJackpot.Start(false));
		this.rubyStartTimer = this.systemContext.TimingContext().CreateRandomInterval("rubyStartTimer", 10000, 30000, () => this.jp3SpriteJackpot.Start(false));
		this.shappireStartTimer = this.systemContext.TimingContext().CreateRandomInterval("shappireStartTimer", 10000, 30000, () => this.jp1SpriteJackpot.Start(false));
		this.emeraldStartTimer = this.systemContext.TimingContext().CreateRandomInterval("emeraldStartTimer", 10000, 30000, () => this.jp2SpriteJackpot.Start(false));
		//this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 10000, 30000, () => this.titleSpriteAnim.Start(false));

		this.allJpTimers.push(this.diamondStartTimer);
		this.allJpTimers.push(this.rubyStartTimer);
		this.allJpTimers.push(this.shappireStartTimer);
		this.allJpTimers.push(this.emeraldStartTimer);

		this.StartAnimations();

		this.Update();

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();
	}

	// deleted too much, this is how this particular game gets displayed to screen,
	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void {
		// animation needs to be updated for frames to go forward
		// this.diamondSpriteAnim.Update();
		// this.rubyAnim.Update();
		// this.shappireAnim.Update();
		// this.emeraldAnim.Update();
		//this.titleSpriteAnim.Update();
		this.jackpotTextMapping[JackpotLevel.Jp4].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3].Draw();
		//Change STYLE JP1 and JP2
		this.jackpotTextMapping[JackpotLevel.Jp1].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2].Draw();
		//UPDATE JACKPOT ANIM
		this.jp4SpriteJackpot.Update();
		this.jp3SpriteJackpot.Update();
		this.jp2SpriteJackpot.Update();
		this.jp1SpriteJackpot.Update();
	}

	public StopAnimations(): void {
		// stop animations and their timer to startup in near future

		// if (this.diamondSpriteAnim != null) this.diamondSpriteAnim.Stop();
		// this.diamondStartTimer.Stop();

		// if (this.rubyAnim != null) this.rubyAnim.Stop();
		// this.rubyStartTimer.Stop();

		// if (this.shappireAnim != null) this.shappireAnim.Stop();
		// this.shappireStartTimer.Stop();

		// if (this.emeraldAnim != null) this.emeraldAnim.Stop();
		// this.emeraldStartTimer.Stop();

		// if (this.titleSpriteAnim != null) this.titleSpriteAnim.Stop();
		// this.titleStartTimer.Stop();
	}

	public StartAnimations(): void {

		//start within 5 seconds
		if (this.jp4SpriteJackpot != null) {
			this.diamondStartTimer.Start();
		}

		if (this.jp3SpriteJackpot != null) {
			this.rubyStartTimer.Start();
		}

		if (this.jp1SpriteJackpot != null) {
			this.shappireStartTimer.Start()
		}

		if (this.jp2SpriteJackpot != null) {
			this.emeraldStartTimer.Start()
		}

		// if (this.titleSpriteAnim != null) {
		// 	this.titleStartTimer.Start()
		// }
	}
	// protected jpValuesSaved: JackpotValue2[] = [];	
	// public UpdateValues(jackpotValues: JackpotValue2[]): void {
	// 	this.jpValuesSaved = jackpotValues;
	// 	if (this.pauseJackpotValues) {
	// 		console.log("IsJackpot");
	// 		return
	// 	}
	// 	//inter
	// 	this.InternalUpdate(this.jpValuesSaved);	
	// }

	public TitleHide() {
		//this.titleSpriteAnim.Hide();
		//this.titleSpriteAnim.Stop();
	}
	public TitleShow() {
		//this.titleSpriteAnim.Show();
		//this.titleStartTimer.Start()
	}

	// public Reset(jpLevel: JackpotLevel) {
	// 	this.jpValuesSaved.forEach((jp) => {
	// 		if (jp.JackpotLevel == jpLevel) {
	// 			console.log("Reset JackpotLevel:", jp.JackpotLevel, "ResetValue:", jp.ResetValue);
	// 			jp.CurrentValue = jp.ResetValue;
	// 			console.log("Current JackpotLevel After Reset:", jp.CurrentValue);
	// 		}
	// 	});
	// 	this.InternalUpdate(this.jpValuesSaved);
	// }

	// public Resume() {		
	// 	this.pauseJackpotValues = false;
	// 	this.jpValuesSaved.forEach((jp) => {
	// 		console.log("Resume JackpotLevel:", jp.JackpotLevel, "CurrentValue:", jp.CurrentValue);
	// 	});
	// 	this.UpdateValues(this.jpValuesSaved);
	// }

	// protected pauseJackpotValues = false;
	// public Pause() {
	// 	console.log("Pause JackpotValues");
	// 	this.pauseJackpotValues = true;
	// }

	// public InternalUpdate(jackpotValues: JackpotValue2[]): void {		
	// 	console.log("Jackpot RedraUpdateJackpotValues:",jackpotValues);
	// 	let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);
	// 	if (jp1 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp1].SetTarget(jp1.CurrentMultipliedValue);
	// 	}

	// 	let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2);
	// 	if (jp2 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp2].SetTarget(jp2.CurrentMultipliedValue);
	// 	}

	// 	let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
	// 	if (jp3 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp3].SetTarget(jp3.CurrentMultipliedValue);
	// 	}

	// 	let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
	// 	if (jp4 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp4].SetTarget(jp4.CurrentMultipliedValue);
	// 	}	
	// }
}
